import { render, staticRenderFns } from "./Forwards.vue?vue&type=template&id=aafbf4c8&scoped=true"
import script from "./Forwards.vue?vue&type=script&lang=js"
export * from "./Forwards.vue?vue&type=script&lang=js"
import style0 from "./Forwards.vue?vue&type=style&index=0&id=aafbf4c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafbf4c8",
  null
  
)

export default component.exports